// Component: ManageTemplateHeader
// Purpose: Header bar for the Manage Templates page, including counts and
// quick action to add a new template when admin.
import React from 'react';
import { PlusCircle } from 'lucide-react';

export default function ManageTemplateHeader({ 
  onNewTemplate, 
  hasTemplates, 
  isAdmin,
  totalCount = 0,
  filteredCount = 0,
  hasFilters = false
}) {
  return (
    <div className="mb-6 flex flex-col space-y-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Manage Templates</h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {hasTemplates 
            ? 'View and manage your advertisement templates' 
            : 'You haven\'t created any templates yet'}
        </p>
        {totalCount > 0 && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {hasFilters 
              ? `Showing ${filteredCount} of ${totalCount} total templates`
              : `Total templates: ${totalCount}`}
          </p>
        )}
      </div>
      
      <div className="flex items-center gap-3">
        {isAdmin && (
          <button
            onClick={onNewTemplate}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:bg-primary-600 dark:hover:bg-primary-700"
          >
            <PlusCircle className="h-4 w-4" />
            New Template
          </button>
        )}
      </div>
    </div>
  );
} 